import { Button, Dialog, Flex, Kbd, Text, TextArea, TextField } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { FormField } from 'shared/components';
import { toast } from 'sonner';
import { useJobApplicants } from '../job-applicants-provider';

function JobApplicantsSendEmailView() {
   const jobApplicants = useJobApplicants();
   const emailSending = jobApplicants.sendEmail.emailSending;
   return (
      <Dialog.Root
         open={jobApplicants.showEmailDialog}
         onOpenChange={(o) => {
            jobApplicants.toggleEmailDialog(o);
            if (!o) {
               jobApplicants.sendEmail.form.reset();
            }
         }}
      >
         <Dialog.Content size="2">
            <form
               className="send-email-applicants"
               onSubmit={(e) => {
                  e.preventDefault();
                  jobApplicants.sendEmail.submit({
                     onSuccess: (res) => {
                        console.log(res);
                        jobApplicants.toggleEmailDialog(false);
                        toast.success('Електронний лист успішно надіслано!');
                     },
                     onError: (e) => {
                        toast.error('Не вдалося відправити електронний лист, спробуйте пізніше', {
                           position: 'top-center',
                        });
                     },
                  });
               }}
            >
               <Flex py="2" px="3" style={{ background: 'var(--blue-11)', color: 'white' }}>
                  <span>Надіслати лист</span>
               </Flex>

               <Flex mt="3" mb="5" py="3" direction="column" gap="2">
                  {jobApplicants.selectedCandidates.map((candidate) => (
                     <Kbd key={candidate.user_id}>{candidate.email_address}</Kbd>
                  ))}
               </Flex>

               <Flex direction="column" gap="4">
                  <FormField
                     label="Тема"
                     error={jobApplicants.sendEmail.form.controls['subject'].error}
                  >
                     <TextField.Root
                        placeholder="Тема"
                        size="3"
                        color="blue"
                        value={jobApplicants.sendEmail.form.controls['subject'].value}
                        onChange={(e) => {
                           jobApplicants.sendEmail.form.controls['subject'].setValue(
                              e.target.value
                           );
                        }}
                     ></TextField.Root>
                  </FormField>

                  <FormField
                     label="Повідомлення"
                     error={jobApplicants.sendEmail.form.controls['message'].error}
                  >
                     <TextArea
                        placeholder="Повідомлення"
                        size="3"
                        color="blue"
                        value={jobApplicants.sendEmail.form.controls['message'].value}
                        onChange={(e) => {
                           jobApplicants.sendEmail.form.controls['message'].setValue(
                              e.target.value
                           );
                        }}
                     ></TextArea>
                  </FormField>
               </Flex>

               <Flex justify="end" gap="3" mt="4">
                  <Button color="red" size="3" type="submit" loading={emailSending}>
                     Надіслати
                  </Button>

                  <Dialog.Close>
                     <Button color="blue" size="3" variant="outline" highContrast>
                        Скасувати
                     </Button>
                  </Dialog.Close>
               </Flex>
            </form>
         </Dialog.Content>
      </Dialog.Root>
   );
}

export const JobApplicantsSendEmail = observer(JobApplicantsSendEmailView);
